<template>
    <rkm-modal
        :buttons="['cancel']"
        :loading="loading"
        title="Laudos importados"
        extraLarge
        ref="Modal"
    >
        <Form
            :item="item"
            :multiple="multiple"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters, mapActions } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        item: [],
        multiple: false
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item, multiple) {

            this.item = item
            this.multiple = multiple
            this.$refs.Modal.show()
        },
    },
}
</script>